<script setup lang="ts">
import { SuggestedBrandsProps } from "./SuggestedBrands.props"
import { sm } from "~/utils/breakpoints"

withDefaults(defineProps<SuggestedBrandsProps>(), {
  bgColor: "bg-tiffany-10"
})
</script>

<template>
  <div class="carousel-container-overflowed padded py-10" :class="bgColor">
    <p class="dolphin-bold md:hyppo-bold mb-4">{{ title }}</p>
    <AppCarousel
      v-if="suggestedCards?.length"
      class="carousel-overflowed select-none"
      :items="suggestedCards"
      :swiper-props="{
        slidesPerView: sm ? 'auto' : suggestedCards?.length <= 2 ? 2 : 3,
        spaceBetween: sm ? 16 : 24,
        grabcursor: true
      }"
      :key="sm ? 1 : 0"
    >
      <template #default="{ item }">
        <CardBrand v-bind="item" />
      </template>
    </AppCarousel>
  </div>
</template>
